import React from 'react';
import { useSelector } from 'react-redux';
import { SpecialMotorsAttributeGroup } from '@gumtree/shared/src/types/attributes';
import { VipState } from '../../reducers';

import MobileMotorsSpecs from './mobile-motors-specs/mobile-motors-specs';
import DesktopMotorsSpecs from './desktop-motors-specs/desktop-motors-specs';
import specMapping from './spec-mapping-experiment-only';

export interface MotorsSpecs extends SpecialMotorsAttributeGroup {
    keyOnly?: boolean;
}

export const MotorsSpecs: React.FC = () => {
    const attributeGroups = useSelector(({ adDetails }: VipState) =>
        'attributeGroups' in adDetails.attributes ? adDetails.attributes.attributeGroups : []
    );
    const isMobile = useSelector(
        ({ baseConfig }: VipState) => baseConfig?.device?.type === 'mobile'
    );

    const slideCount = attributeGroups.length || 0;
    if (slideCount > 0) {
        const data = specMapping(attributeGroups);
        const attributeGroupsWithData = data.filter((t) => t.attributes.length > 0);
        return isMobile ? (
            <MobileMotorsSpecs
                attributeGroups={attributeGroupsWithData}
            />
        ) : (
            <DesktopMotorsSpecs attributeGroups={attributeGroupsWithData} />
        );
    }
    return null;
};

export default MotorsSpecs;
